import { z } from "zod";
import type { ApiClient } from "../auth/apiClient";

/**
 * Mirror of the backend `SessionResponse` (Galileo.Office.Api.Features.Session).
 * Validated at the boundary so downstream consumers receive a typed object
 * and never a parsed-but-unverified JSON blob.
 */
const SessionResponseSchema = z.object({
    userId: z.string(),
    displayName: z.string(),
    username: z.string(),
    tenantId: z.string(),
    scopes: z.array(z.string()),
    /**
     * App roles granted to the caller (e.g. `"Editor"`). Drives the
     * SPA's edit/view UX gates (`useCanEdit`). The API is the
     * authoritative enforcer; this list is for chrome only.
     */
    roles: z.array(z.string()).default([]),
});

export type SessionResponse = z.infer<typeof SessionResponseSchema>;

const ServiceInfoResponseSchema = z.object({
    service: z.string(),
    status: z.string(),
});

export type ServiceInfoResponse = z.infer<typeof ServiceInfoResponseSchema>;

export async function fetchSession(client: ApiClient): Promise<SessionResponse> {
    const raw = await client.getJson<unknown>("/api/session");
    return SessionResponseSchema.parse(raw);
}

export async function fetchServiceInfo(client: ApiClient): Promise<ServiceInfoResponse> {
    const raw = await client.getJson<unknown>("/api/service-info");
    return ServiceInfoResponseSchema.parse(raw);
}
